import React, { useState } from 'react';

import { trans, getResourcePath } from '@spotahome/soyuz/client';
import { HeaderContainer } from '@spotahome/ui-library';
import Metrics from '@spotahome/soyuz-metrics';

import { getReferrerCodeByEmail } from '../../common/graphql/queries/referral';
import graphqlClient from '../../common/graphql/client';

import Footer from '../../common/components/Footer';
import Hero from '../../common/components/Hero';

import { getReferrerLink } from './common/utils';

import HowItWorks from './components/HowItWorks';
import Form from './components/Form';
import FormSuccess from './components/FormSuccess';

import './../../common/scss/init.scss';
import './main.scss';

const ReferAFriendContainer = () => {
  const [code, setCode] = useState('');
  const [userName, setUserName] = useState('');

  const handleFormData = async formData => {
    Metrics.ga.sendEvent(
      'create_referral',
      'create_your_referral_code',
      'click_get_your_code'
    );
    const { firstName, lastName, email } = formData;
    setUserName(firstName);
    const referralCodeResponse = await getReferrerCodeByEmail(graphqlClient())({
      input: {
        email,
        lastName,
        firstName
      }
    });
    const { referralCode } = referralCodeResponse.data.getReferrerCodeByEmail;
    setCode(referralCode);
  };

  return (
    <div>
      <Hero
        menu={
          <HeaderContainer
            locales={{ current: 'en' }}
            login={false}
            showMobileMenu={false}
            links={{
              home: false,
              listYourProperty: false,
              howItWorks: false,
              favorites: false
            }}
          />
        }
        title={trans('external.refer_a_friend.hero.title')}
        subtitle={trans('external.refer_a_friend.hero.subtitle')}
        size="big"
        colorTitle="dark"
        colorSubtitle="dark"
        isRowAlignContent
        className="hero__wrapper--fit"
        image={getResourcePath(
          '/images/refer-a-friend/referral-illustration.svg'
        )}
      />
      <div className="form__section__wrapper">
        {code ? (
          <FormSuccess
            code={code}
            link={code ? getReferrerLink({ code }) : ''}
            userName={userName}
          />
        ) : (
          <Form onFormSubmission={handleFormData} />
        )}
      </div>
      <HowItWorks />
      <Footer />
    </div>
  );
};

export default ReferAFriendContainer;
